import type { Dict } from '../../i18n/types';
import { paulAssetPath } from './assets';

export const paulBrand = {
  appName: 'Paul Design',
  logoUrl: paulAssetPath('/paul-logo.png'),
  maskIconColor: '#1F1B16',
  themeColor: '#F4EFE6',
} as const;

export const paulLocaleOverrides = {
  en: {
    'app.brand': paulBrand.appName,
    'entry.tabDesigns': 'Career pages',
    'settings.welcomeTitle': `Set up ${paulBrand.appName}`,
    'chat.startHint':
      'Drop or paste images for visual context. Or try one of these starters:',
    'chat.composerPlaceholder':
      'Describe what you want — paste or drop images for visual context…',
    'chat.composerHint':
      '⌘/Ctrl + Enter to send · paste images for visual context',
    'designFiles.empty': 'No files yet.',
    'designFiles.dropDesc': 'Images, docs, references, or folders — attach them to this project as context.',
    'homeHero.title': 'What career page do you want to build?',
  } as Partial<Dict>,
  de: {
    'app.brand': paulBrand.appName,
    'entry.tabDesigns': 'Karriereseiten',
    'settings.welcomeTitle': `${paulBrand.appName} einrichten`,
    'chat.startHint':
      'Füge Bilder per Drag-and-drop oder Einfügen als visuellen Kontext hinzu. Oder starte mit einer dieser Ideen:',
    'chat.composerPlaceholder':
      'Beschreibe, was du brauchst — füge Bilder als visuellen Kontext ein…',
    'chat.composerHint':
      '⌘/Strg + Enter zum Senden · Bilder als visuellen Kontext einfügen',
    'designFiles.empty': 'Noch keine Dateien.',
    'designFiles.dropDesc': 'Bilder, Dokumente, Referenzen oder Ordner — füge sie diesem Projekt als Kontext hinzu.',
    'homeHero.title': 'Welche Karriereseite möchtest du erstellen?',
  } as Partial<Dict>,
};

export function applyPaulLocaleOverrides(locale: string, dict: Dict): Dict {
  const overrides = paulLocaleOverrides[locale as keyof typeof paulLocaleOverrides];
  return overrides ? { ...dict, ...overrides } : dict;
}
